import { useContext } from "react";
import { store } from "../store.js";
import useGetValueFromArray from "./useGetValueFromArray.js";
import useGetMappingByControl from "./useGetMappingByControl";
import useGetApiData from "./useGetApiData.js";

const useSetActualizeData = () => {
  const getValueFromArray = useGetValueFromArray();
  const getMappingByControl = useGetMappingByControl();
  const getApiData = useGetApiData();

  const setActualizeData = (control, apiId, apiData) => {
    const currentMapping = getMappingByControl(control)

    if(currentMapping && currentMapping.value[0] == apiId) {
      control.properties.actualize.value = control.properties.actualize.value + 1
    
      const dataSourcePath = currentMapping.value
      const pathName = getValueFromArray(dataSourcePath).name
      let pathNames =  pathName.split(".")
      pathNames = pathNames.slice(1, pathNames.length)
        
      const data = getApiData(pathNames, apiData)

      const isArray = Array.isArray(data)
      control.properties.size.value = isArray ? data.length : 0
    }
      
  };

  return setActualizeData;
};

export default useSetActualizeData;
